import Menu, { MenuProps } from './Menu'
import MenuItem from './MenuItem'

export type { MenuProps }
export { MenuItem }

const MenuComponent = {
  Menu,
  MenuItem,
}
export default MenuComponent
